import React from 'react';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import DatePicker from '../../../components/fields/DatePicker/DatePicker';
import DateTimePicker from '../../../components/fields/DatePicker/DateTimePicker';
import TextInput from '../../../components/fields/TextInput/TextInput';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import CustomSelectInput from '../../../components/fields/SelectInput/CustomSelectInput';
import CustomSelectInputWithHelper from '../../../components/fields/SelectInput/CustomSelectInputWithHelper';
import RegistryNumberSelector from '../../../components/fields/SelectInput/RegistryNumberSelector';
import TextSearchInput from '../../../components/fields/TextInput/TextSearchInput';
import RangeDatePicker from '../../../components/fields/RangeDatePicker/RangeDatePicker';
import MultipleSelectInputWithAsyncHelper from '../../../components/fields/SelectInput/MultipleSelectInputWithAsyncHelper';
import MultiTextInput from '../../../components/fields/MultiTextInput/MultiTextInput';
import SelectInputWithHelper from '../../../components/fields/SelectInput/SelectInputWithHelper';
import { carrierHelper, szltHelper, vehiclesHelper } from '../../RegionRegistry/actions';
import { loadLegalEntityFormList } from '../../Application/actions';
import { loadUserList } from '../../User/actions';
import { PAGE_TYPE_LIST } from './filter-settings';
import DateTimeRangePicker from '../../../components/fields/RangeDatePicker/DateTimeRangePicker';
import RegistryNumberSelectorById from '../../../components/fields/SelectInput/RegistryNumberSelectorById';
import { loadNotificationTypes } from '../../Authorized/actions';
import MapInput from '../../../components/fields/MapInput/MapInput';
import { loadApplicantList } from '../../Applicant/actions';

const loadActionEnum = {
  szltHelper,
  vehiclesHelper,
  carrierHelper,
  loadLegalEntityFormList,
  loadUserList,
  loadApplicantList,
  loadNotificationTypes,
};

const optionFormatterEnum = {
  full_name_full_name: item => ({ value: item.full_name, name: item.full_name }),
  id_full_name: item => ({ value: item.id, name: item.full_name }),
  number_number: item => ({ value: item.number, name: item.number }),
  value_label: item => ({ value: item.value, name: item.label }),
};

const filterComponentEnum = {
  DatePicker,
  DateTimePicker,
  TextInput,
  TextInputWithLabel,
  CustomSelectInput,
  CustomSelectInputWithHelper,
  RegistryNumberSelector,
  TextSearchInput,
  RangeDatePicker,
  MultipleSelectInputWithAsyncHelper,
  MultiTextInput,
  SelectInputWithHelper,
  DateTimeRangePicker,
  RegistryNumberSelectorById,
  MapInput,
};

export const renderFilter = (settings = [], control, page = '') => {
  let currentSettings = settings;
  if (page) {
    const selectedPage = PAGE_TYPE_LIST.find(p => p.value === page);
    const filter = selectedPage?.filter;
    currentSettings = filter.reduce((acc, cur) => {
      const group = settings.find(g => g.groupName === cur.groupName);
      if (group?.enable && group?.children?.length && cur?.children?.length) {
        const newGroup = { ...cur, sortIndex: group.sortIndex, enable: group.enable };
        newGroup.children = cur.children.reduce((acc2, cur2) => {
          const field = group.children.find(f => f.dto.name === cur2.dto.name);
          if (field?.enable) {
            const res = { ...cur2, sortIndex: field.sortIndex, enable: field.enable };
            if (field.options?.length) {
              res.options = field.options;
            }
            acc2.push(res);
          }
          return acc2;
        }, []);
        acc.push(newGroup);
      }
      return acc;
    }, []);
  }

  const sortedConfig = currentSettings.sort((a, b) => a.sortIndex - b.sortIndex).map(g => {
    g.children = g.children.sort((a, b) => a.sortIndex - b.sortIndex);
    return g;
  });

  return sortedConfig.filter(item => item.enable).map((group, key) => (
    <div className="filter-group" key={key}>
      <div className="filter-group-name mt-3">{group.groupName}</div>
      {renderFilterGroup(group, control)}
    </div>
  ));
};
// , group.namePrefix, group.labelPrefix
export const renderFilterGroup = (group, control) => group.children.filter(item => item.enable).map((field, key) => {
  const addProps = {
    component: filterComponentEnum[field.component],
  };
  if (field.loadAction) {
    addProps.loadAction = loadActionEnum[field.loadAction];
  }
  if (field.optionFormatter) {
    addProps.optionFormatter = optionFormatterEnum[field.optionFormatter];
  }
  if (field.options) {
    addProps.options = field.options.filter(item => item.enable);
  }
  if (group.labelPrefix) {
    addProps.labelPrefix = group.labelPrefix;
  }
  return (
    <FieldDTO
      key={key}
      control={control}
      dtoObject={field.dto}
      namePrefix={group.namePrefix}
      {...field}
      {...addProps}
    />
  );
});

export const renderRowFilter = (settings = [], control, page = '') => {
  let currentSettings = settings;
  if (page) {
    const selectedPage = PAGE_TYPE_LIST.find(p => p.value === page);
    const filter = selectedPage?.filter;
    currentSettings = filter.reduce((acc, cur) => {
      const group = settings.find(g => g.groupName === cur.groupName);
      if (group?.enable && group?.children?.length && cur?.children?.length) {
        const newGroup = { ...cur, sortIndex: group.sortIndex, enable: group.enable };
        newGroup.children = cur.children.reduce((acc2, cur2) => {
          const field = group.children.find(f => f.dto.name === cur2.dto.name);
          if (field?.enable) {
            const res = { ...cur2, sortIndex: field.sortIndex, enable: field.enable };
            if (field.options?.length) {
              res.options = field.options;
            }
            acc2.push(res);
          }
          return acc2;
        }, []);
        acc.push(newGroup);
      }
      return acc;
    }, []);
  }

  const sortedConfig = currentSettings.sort((a, b) => a.sortIndex - b.sortIndex).map(g => {
    g.children = g.children.sort((a, b) => a.sortIndex - b.sortIndex);
    return g;
  });

  return sortedConfig.filter(item => item.enable).map((group, key) => renderFilterGroup(group, control));
};
